addEventListener("DOMContentLoaded", (event) => {
    const audioContainer = document.querySelector('.product-player');
    const playerAudio = document.querySelector('.player__audio');
    const playButton = playerAudio.getAttribute('data-play');
    const pauseButton = playerAudio.getAttribute('data-pause');
    const tabSelect = document.querySelector('.player-tab-select');
    const offsetConstant = 245;

    let pdpPlays = document.querySelectorAll('.pdp-play');
    let playTrack = document.querySelector('.play-container');
    let productPlayer = document.querySelector('.product-player');
    let metafieldPlaylist = document.querySelector('.metafield-playlist');
    let metafieldPlaylistPaddingTop = parseFloat(window.getComputedStyle(metafieldPlaylist).paddingTop);
    let metafieldSection = metafieldPlaylist.parentElement;
    let heading = metafieldSection.querySelector('.heading');
    let player_offset = metafieldSection.offsetTop - window.innerHeight + offsetConstant + heading.offsetHeight + metafieldPlaylistPaddingTop;

    let wavesurferInstances = new Map();
    let trackCount = 0;
    let waveIdCounter = 0;

    const tabData = audioContainer.dataset.tabs;
    const tabs = tabData.split(',');
    let progressColor = audioContainer.dataset.progressColor;
    let waveColor = audioContainer.dataset.waveColor;

    function renderTracks(selectedTabIndex = 0) {
        const tab = tabs[selectedTabIndex];
        const tracksTab = document.querySelector(`[data-${tab}]`);
        const tracksArr = tracksTab.getAttribute(`data-${tab}`).split(',');

        let tabContainer = document.createElement('div');
        let waveHolder = document.createElement('div');

        productPlayer.innerHTML = '';
        tabContainer.classList.add('player-tab');

        const recordName = document.querySelector('.player__audio').getAttribute('data-record_name');
        waveHolder.classList.add('wave-holder');

        audioContainer.appendChild(tabContainer);
        tabContainer.appendChild(waveHolder);

        tracksArr.forEach((trackUrl, index) => {
            if (trackUrl) {
                const peaks = trackUrl.replace('.mp3', '.mp3.json');
                const sanitised = trackUrl;

                const audio = {};
                audio.trackUrl = trackUrl;
                audio.trackName = sanitised;
                audio.trackPosition = index;
                audio.trackPeaksUrl = peaks;
                audio.recordName = recordName;
                audio.recordCover = audioContainer.getAttribute('data-record_cover');
                audio.preload = 'none';
                audio.type = tab;
                buildTrack(audio, tabContainer);

                playTrack = document.querySelector('.play-container');
            }
        });

        const viewMoreContainer = document.createElement('div');
        const viewMore = document.createElement('span');
        const closeButton = document.createElement('button');

        closeButton.className = "btn-close";
        closeButton.innerHTML = `<span aria-hidden="true">\×</span>`;

        tabContainer.querySelector('.wave-holder').appendChild(closeButton);

        if (tracksArr.length > 3) {
            viewMoreContainer.classList.add('view-more-container');

            viewMore.textContent = 'Show more';
            viewMore.className = 'view-more-less btn btn--secondary';

            viewMoreContainer.appendChild(viewMore);
            tabContainer.appendChild(viewMoreContainer);

            viewMore.addEventListener('click', function() {
                if (viewMore.classList.contains('extended')) {
                    viewMore.textContent = "Show more";
                    viewMore.classList.remove('extended');
                    tabContainer.classList.remove('extended');
                    metafieldPlaylist.scrollIntoView();
                } else {
                    viewMore.textContent = "Show less";
                    viewMore.classList.add('extended');
                    tabContainer.classList.add('extended');
                }
            });
        }

        async function buildTrack(audio, tabContainer) {
            let trackName = audio.trackName.split('/').pop().split('.mp3').shift().replaceAll('_', ' ').replace(`${audio.recordName} - `, '');
            let playContainer = document.createElement('div');
            let playWaveContainer = document.createElement('div');

            playContainer.innerHTML = `<button class="play-container"><span class="play-track" style="display:inline-block">${playButton}</span>
    <span class="pause-track">${pauseButton}</span> <span class="uppercase font-bold ml-2">${audio.recordName} - ${trackName}</span></button>`;
            playContainer.setAttribute('id', trackName);
            playContainer.classList.add('wave-container');

            if (progressColor === '#') {
                progressColor = 'rgba(255 215 55)';
            }

            if (waveColor === '#') {
                waveColor = 'rgba(255 255 255)';
            }

            let commonWaveConfig = {
                waveColor: waveColor,
                progressColor: progressColor,
                cursorColor: waveColor,
                autoCenter: false,
                barWidth: 2,
                barHeight: 0.9,
                barGap: 3,
                height: 100,
                responsive: true,
                normalize: true,
                backend: 'WebAudio',
            };

            let playWave = WaveSurfer.create({
                ...commonWaveConfig,
                container: playWaveContainer
            });

            playWave.id = waveIdCounter++;

            wavesurferInstances.set(playContainer, playWave);
            playContainer.appendChild(playWaveContainer);
            tabContainer.querySelector('.wave-holder').appendChild(playContainer);

            // Fetch peaks for visualization
            await fetch(audio.trackPeaksUrl)
                .then(response => {
                    if (response.status !== 200) {
                        playWave.load(audio.trackUrl, audio.trackPeaks);
                        throw new Error('Data peaks file doesn\'t exist');
                    }
                    return response.json();
                })
                .then(peaks => {
                    playWave.trackPeaks = peaks.data;
                    playWave.load(null, peaks.data, peaks.data.length);
                })
                .catch(e => console.error('Error fetching peaks:', e));

            playWave.trackUrl = audio.trackUrl;
            playWave.trackLoaded = false;

            playWave.on('pause', function () {
                if (playWave.id === 0) {
                    updatePdpIcons(false);
                }

                updatePdpIcons(false);
                playContainer.querySelector('.play-track').style.display = 'inline-block';
                playContainer.querySelector('.pause-track').style.display = 'none';
            });

            playWave.on('play', function () {
                if (playWave.id === 0) {
                    updatePdpIcons(true);
                }

                document.querySelectorAll('.wave-container').forEach(waveContainer => {
                    const wave = wavesurferInstances.get(waveContainer);
                    if (wave && wave !== playWave) {
                        wave.pause();
                    }
                });

                // Pause all audios and videos
                let pauseVideosEvent = new Event('videos:pause');
                let pauseSoundbarAudioEvent = new Event('soundbar:pause');
                document.dispatchEvent(pauseVideosEvent);
                document.dispatchEvent(pauseSoundbarAudioEvent);

                updatePdpIcons(true);
                playContainer.querySelector('.play-track').style.display = 'none';
                playContainer.querySelector('.pause-track').style.display = 'inline-block';
            });

            playWave.on('finish', function() {
                const nextPlayContainer = playContainer.nextSibling;
                nextPlayContainer?.querySelector('.play-container').click();
            });

            playWave.on('click', function (x, y) {
                document.querySelectorAll('.wave-container').forEach(waveContainer => {
                    const wave = wavesurferInstances.get(waveContainer);
                    if (wave !== playWave) {
                        wave.pause();
                    }
                });

                if (!playWave.isPlaying()) {
                    if (!playWave.trackLoaded) {
                        playWave.once('ready', function () {
                            playWave.seekTo(x);
                            playWave.play();
                            playWave.trackLoaded = true;
                        });
                        playWave.load(playWave.trackUrl, playWave.trackPeaks);
                    } else {
                        playWave.seekTo(x);
                        playWave.play();
                    }
                }

                playContainer.querySelector('.play-track').style.display = 'none';
                playContainer.querySelector('.pause-track').style.display = 'inline-block';
            });

            playContainer.querySelector('.play-container').addEventListener('click', function (event) {
                event.stopPropagation();

                if (playWave.isPlaying()) {
                    playWave.pause();
                } else {
                    if (!playWave.trackLoaded) {
                        playWave.once('ready', function () {
                            playWave.play();
                            playWave.trackLoaded = true;
                        });
                        playWave.load(playWave.trackUrl, playWave.trackPeaks);
                    } else {
                        playWave.play();
                    }

                    // Pause all audios and videos
                    let pauseVideosEvent = new Event('videos:pause');
                    let pauseSoundbarAudioEvent = new Event('soundbar:pause');
                    document.dispatchEvent(pauseVideosEvent);
                    document.dispatchEvent(pauseSoundbarAudioEvent);
                }
            });

            trackCount += 1;
        }

        closeButton.addEventListener('click', function() {
            let pauseProductAudioEvent = new Event('product:audio:pause');
            document.dispatchEvent(pauseProductAudioEvent);

            updatePdpIcons(false);

            document.querySelector('.wave-holder').style.height = 'unset';
            metafieldPlaylist.classList.remove('fixed');
            productPlayer.style.width = 'unset';
        });
    }

    renderTracks(0);

    function updatePdpIcons(isPlaying) {
        const pdpPlays = document.querySelectorAll('.pdp-play');

        pdpPlays.forEach(function (pdpPlay) {
            let pdpPlayIcon = pdpPlay.querySelector('svg.icon-play');
            let pdpPauseIcon = pdpPlay.querySelector('svg.icon-pause');

            if (isPlaying) {
                pdpPlayIcon.style.display = "none";
                pdpPauseIcon.style.display = "block";
            } else {
                pdpPlayIcon.style.display = "block";
                pdpPauseIcon.style.display = "none";
            }
        });
    }

    pdpPlays.forEach(function(pdpPlay) {
        pdpPlay.addEventListener('click', function () {
            playTrack.click();

            if (window.scrollY <= player_offset && !metafieldPlaylist.classList.contains('fixed')) {
                document.querySelector('.wave-holder').style.height = 'unset';
                metafieldPlaylist.classList.add('fixed');
                productPlayer.style.width = '100%';
                productPlayer.style.opacity = '1';
            }
        });
    });

    tabSelect.addEventListener('change', function() {
        const selectedTabIndex = this.value;

        renderTracks(selectedTabIndex);
    });

    window.addEventListener('resize', function() {
        player_offset = metafieldSection.offsetTop - window.innerHeight + offsetConstant + heading.offsetHeight;
    });

    window.addEventListener('scroll', function () {
        const isFirstTrackPlaying = document.querySelector('.wave-container:first-child .pause-track').offsetHeight > 0;

        if (window.scrollY > player_offset && metafieldPlaylist.classList.contains('fixed')) {
            productPlayer.style.width = 'unset';
            metafieldPlaylist.classList.remove('fixed');
        } else if (window.scrollY <= player_offset && isFirstTrackPlaying) {
            productPlayer.style.width = '100%';
            metafieldPlaylist.classList.add('fixed');
        }
    });

    document.addEventListener('product:audio:pause', function(e) {
        document.querySelectorAll('.wave-container').forEach(waveContainer => {
            const wave = wavesurferInstances.get(waveContainer);

            wave.pause();
            waveContainer.querySelector('.play-track').style.display = 'inline-block';
            waveContainer.querySelector('.pause-track').style.display = 'none';
        });
    });
});